var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 7.75C3.25 8.87717 3.69777 9.95817 4.4948 10.7552C5.29183 11.5522 6.37283 12 7.5 12C8.62717 12 9.70817 11.5522 10.5052 10.7552C11.3022 9.95817 11.75 8.87717 11.75 7.75C11.75 6.62283 11.3022 5.54183 10.5052 4.7448C9.70817 3.94777 8.62717 3.5 7.5 3.5C6.37283 3.5 5.29183 3.94777 4.4948 4.7448C3.69777 5.54183 3.25 6.62283 3.25 7.75V7.75Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 20.5C0.5 18.6435 1.2375 16.863 2.55025 15.5503C3.86301 14.2375 5.64348 13.5 7.5 13.5C9.35652 13.5 11.137 14.2375 12.4497 15.5503C13.7625 16.863 14.5 18.6435 14.5 20.5H0.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 20.4999H23.4999C23.4999 19.556 23.2569 18.628 22.7945 17.8051C22.332 16.9823 21.6655 16.2924 20.8592 15.8016C20.0529 15.3109 19.1338 15.036 18.1905 15.0033C17.2472 14.9706 16.3113 15.1812 15.4729 15.6149",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6941 10.25C14.6941 10.6768 14.7782 11.0994 14.9415 11.4937C15.1048 11.888 15.3442 12.2463 15.646 12.5481C15.9478 12.8499 16.3061 13.0893 16.7004 13.2526C17.0947 13.4159 17.5173 13.5 17.9441 13.5C18.3709 13.5 18.7935 13.4159 19.1878 13.2526C19.5821 13.0893 19.9404 12.8499 20.2422 12.5481C20.544 12.2463 20.7834 11.888 20.9467 11.4937C21.11 11.0994 21.1941 10.6768 21.1941 10.25C21.1941 9.8232 21.11 9.40059 20.9467 9.00628C20.7834 8.61197 20.544 8.25369 20.2422 7.9519C19.9404 7.65011 19.5821 7.41072 19.1878 7.24739C18.7935 7.08406 18.3709 7 17.9441 7C17.5173 7 17.0947 7.08406 16.7004 7.24739C16.3061 7.41072 15.9478 7.65011 15.646 7.9519C15.3442 8.25369 15.1048 8.61197 14.9415 9.00628C14.7782 9.40059 14.6941 9.8232 14.6941 10.25V10.25Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/Customers.a64cc5d2b6a41d3ee5929126cbe21806.svg";
export { ForwardRef as ReactComponent };